"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaxAttributePercentDecreaseEffectHandler = exports.MaxAttributePercentDecreaseEffectArgs = void 0;
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const enums_1 = require("../../enums");
const Attributes_1 = require("../../../metadata/Attributes");
const Enum_1 = require("../../../utils/Enum");
class MaxAttributePercentDecreaseEffectArgs {
    constructor(attribute, percentOfBase) {
        this.attribute = attribute;
        this.percentOfBase = percentOfBase;
        this.__type = EffectType_1.EffectType.MaxAttributePercentDecrease;
        this.__typeName = "MaxAttributePercentDecrease";
        this.name = "MaxAttributePercentDecrease";
        this.harmful = !Boolean(Attributes_1.AttributeIsHarmful[(0, Enum_1.enumValue)(enums_1.AttributeType, attribute)]);
    }
}
exports.MaxAttributePercentDecreaseEffectArgs = MaxAttributePercentDecreaseEffectArgs;
let MaxAttributePercentDecreaseEffectHandler = class MaxAttributePercentDecreaseEffectHandler {
    apply(sequence, container, state) {
        state.meta.amount = container.getPercentOfBaseAttributeScore(state.targetId, state.args.percentOfBase, state.args.attribute);
        const last = container.getMaxAttributeScore(state.targetId, state.args.attribute);
        const attr = (0, Enum_1.enumValue)(enums_1.AttributeType, state.args.attribute);
        if ((0, enums_1.isPrimaryAttribute)(attr) || attr === enums_1.AttributeType.Health) {
            state.meta.amount = Math.min(last, state.meta.amount);
        }
        container.setMaxAttributeScore(sequence, state.targetId, state.args.attribute, last - state.meta.amount);
    }
    remove(sequence, container, state) {
        const last = container.getMaxAttributeScore(state.targetId, state.args.attribute);
        container.setMaxAttributeScore(sequence, state.targetId, state.args.attribute, last + state.meta.amount);
    }
};
MaxAttributePercentDecreaseEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.MaxAttributePercentDecrease)
], MaxAttributePercentDecreaseEffectHandler);
exports.MaxAttributePercentDecreaseEffectHandler = MaxAttributePercentDecreaseEffectHandler;
